import React from "react";
import { motion } from "framer-motion";
import { STATUS, thresholdStatus, statusClasses } from "../../data/statusColors";
import { useTranslate } from "../../i18n/useTranslate";

const ALERT_BANDS = [
  { min: 6, bucket: "critical" },
  { min: 3, bucket: "warning" },
  { min: 0, bucket: "good" },
];

export default function DepartmentCard({ dept, index = 0 }) {
  const t = useTranslate();
  const pct = Math.round((dept.active / dept.total) * 100);
  const alertBucket = thresholdStatus(dept.alerts, ALERT_BANDS);

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.06 }}
      className="card card-hover p-4"
    >
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2.5">
          <div className="w-3 h-8 rounded-full flex-shrink-0" style={{ background: dept.color }} />
          <div>
            <div className="text-sm font-black text-slate-900">{t(dept.name)}</div>
            <div className="text-[10px] text-slate-500">{dept.active.toLocaleString()} / {dept.total.toLocaleString()} {t("deployed")}</div>
          </div>
        </div>
        <span className={`text-xs font-black px-2 py-1 rounded-full ${statusClasses(alertBucket)}`}>{dept.alerts} {t("alerts")}</span>
      </div>

      <div className="space-y-1.5">
        <div>
          <div className="flex justify-between text-[10px] text-slate-500 mb-1">
            <span>{t("Deployment")}</span>
            <span className="font-bold">{pct}%</span>
          </div>
          <div className="h-1.5 rounded-full bg-slate-100 overflow-hidden">
            <motion.div
              initial={{ width: 0 }}
              animate={{ width: `${pct}%` }}
              transition={{ delay: index * 0.06 + 0.2, duration: 0.7 }}
              className="h-1.5 rounded-full"
              style={{ background: dept.color }}
            />
          </div>
        </div>
        <div>
          <div className="flex justify-between text-[10px] text-slate-500 mb-1">
            <span>{t("Resolution Rate")}</span>
            <span className="font-bold" style={{ color: STATUS.good.hex }}>{dept.resolved}%</span>
          </div>
          <div className="h-1.5 rounded-full bg-slate-100 overflow-hidden">
            <motion.div
              initial={{ width: 0 }}
              animate={{ width: `${dept.resolved}%` }}
              transition={{ delay: index * 0.06 + 0.3, duration: 0.7 }}
              className="h-1.5 rounded-full"
              style={{ background: STATUS.good.hex }}
            />
          </div>
        </div>
      </div>
    </motion.div>
  );
}
